/**
 * <marquee-track> web component.
 *
 * Wraps a list of `.marquee__item` children and sets `--marquee-items` on the
 * host and `--marquee-item-index` on each child. Indexing runs in
 * `connectedCallback` and again whenever children are added, removed or
 * reordered (MutationObserver), so items that arrive later through a fetch
 * or section re-render are indexed too.
 */
class MarqueeTrack extends HTMLElement {
  #observer = new MutationObserver(() => this.#indexItems());

  connectedCallback() {
    this.#indexItems();
    this.#observer.observe(this, { childList: true });
  }

  disconnectedCallback() {
    this.#observer.disconnect();
  }

  #indexItems() {
    const items = Array.from(this.children);

    this.style.setProperty('--marquee-items', items.length);

    items.forEach((item, index) => {
      item.style.setProperty('--marquee-item-index', index + 1);
    });
  }
}

if (!customElements.get('marquee-track')) {
  customElements.define('marquee-track', MarqueeTrack);
}

